/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_db867a99{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.root_db867a99 .dropdown_db867a99{margin-bottom:0;margin-left:5px}\n"}]);
export const root = "root_db867a99";
export const dropdown = "dropdown_db867a99";